import type { QuickReply } from '@zerohuman/shared'

/** One thing setup asks for, as the server-held setup view serves it to both paths (#1739). */
export interface TeamSetupItemView {
    kind: 'github_repo' | 'tool' | 'first_work'
    /** The display name, never a slug or tool id. */
    name: string
    /** Why the team needs it, in plain words. */
    reason: string
    /** What the Connect button opens: the tool type to connect, or null for the first piece of work. */
    connect: string | null
}

/**
 * What the team cloned during setup still needs, as the server works it out (#1739). The portal never orders,
 * filters or completes it: it shows `current`, and `message` when the team cannot start.
 */
export interface TeamSetupView {
    items: TeamSetupItemView[]
    /** The item to show now, or null when nothing is left. */
    current: TeamSetupItemView | null
    /** False while a GitHub repo or a tool is missing. */
    canStart: boolean
    /** The plain-words report of what is missing, or null when nothing is. */
    message: string | null
}

/**
 * The setup conversation's Connect chip at team setup (#1739): one, for the current item the server serves, when it is
 * a connection. Its label is the display name and its value the tool type the Tools connect flow opens on. None for
 * the first piece of work, or when nothing is left: the chat never offers a later item.
 */
export function teamSetupConnectReplies(view: TeamSetupView | null | undefined): QuickReply[] {
    const current = view?.current
    return current?.connect ? [{ label: `Connect ${current.name}`, value: current.connect }] : []
}

/** The Tools page, opened on the connect flow for one tool type: what a setup item's Connect button goes to. */
export function connectToolLocation(toolType: string): { path: string; query: { connect: string } } {
    return { path: '/tools', query: { connect: toolType } }
}
